import apiClient from '@/lib/api';
import type { ClassifiedLine } from '@/types';

// Convert integer pence to the decimal pound string the server expects ("1234.56")
function pencesToString(pence: number): string {
  return (pence / 100).toFixed(2);
}

// Create a new classified line for entity+period
export async function createLine(
  entityId: string,
  period: string,
  payload: { cfCodeId: string; amountPence: number; notes?: string },
): Promise<ClassifiedLine> {
  const { data } = await apiClient.post(
    `/classified-lines/entity/${entityId}/period/${period}`,
    {
      cfCodeId: payload.cfCodeId,
      amountPence: pencesToString(payload.amountPence),
      notes: payload.notes ?? null,
    },
  );
  return data.classifiedLine ?? data;
}

// Update an existing classified line by ID
export async function updateLine(
  lineId: string,
  payload: { amountPence: number; notes?: string },
): Promise<ClassifiedLine> {
  const { data } = await apiClient.patch(`/classified-lines/${lineId}`, {
    amountPence: pencesToString(payload.amountPence),
    notes: payload.notes ?? undefined,
  });
  return data.classifiedLine ?? data;
}

// Soft-delete a classified line
export async function deleteLine(lineId: string): Promise<void> {
  await apiClient.delete(`/classified-lines/${lineId}`);
}
